import React, { Component } from "react";

import { Link } from "react-router-dom";
import { Menu } from "semantic-ui-react";
import {withRouter} from 'react-router'
import Footer from "../../Footer";
import menus from "../Helpers/menus";
import colors from "../../colors";

import HeaderCommon from "../../HeaderCommon";
import decode from "jwt-decode";
import {
  Navbar,
  NavbarNav,
  NavbarToggler,
  Collapse,
  NavItem,
  NavLink,
  Button,
} from "mdbreact";
import { AuthConsumer } from "../../AuthContext";
import info from '../../info.png'
class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      isWideEnough: false,
      dropdownOpenAbout: false,
      dropdownOpenTeams: false,
      dropdownOpenProjects: false,
      active:props.match.url==='/webgis-vic'?'HMS Home':props.match.url==='/webgis-vic/map'?'HMS Geoportal':props.match.url==='/webgis-vic/proj-obj'?'Objective':null,
      isOpen: false,
      vicmodal:true,
    };
  }
 toggle=()=>{
   this.setState({
    vicmodal:!this.state.vicmodal
   })
   
 }
  onClick = () => {
    this.setState({
      collapse: !this.state.collapse,
    });
  };
  _handleClick(menuItem) {
    this.setState({ active: menuItem });
    this.onClick()
  }
  componentDidUpdate(prevProps,prevState)
  {
    if(this.props.match.url!==prevProps.match.url)
    {
     this.setState({
      active:this.props.match.url==='/webgis-vic'?'HMS Home':this.props.match.url==='/webgis-vic/map'?'HMS Geoportal':this.props.match.url==='/webgis-vic/proj-obj'?'Objective':null,
     })
    }
  }
  render() {
    const activeStyle = { color: "#ff3333" };
    let menuList = menus.head.map((menu, key) => {
      return (
        <NavItem key={key}>
          <NavLink to={menu.path} key={key}>
            <Menu.Item
              name={menu.name}
              style={this.state.active === menu.name ? activeStyle : {}}
              onClick={this._handleClick.bind(this, menu.name)}
            />
          </NavLink>
        </NavItem>
      );
    });
   // const vicmodal=this.state.vicmodal
   const childrenWithExtraProp = React.Children.map(
      this.props.children,
      (child, i) => {
        return React.cloneElement(child, {
        //this properties are available as a props in child components
         vicmodal:this.state.vicmodal,
          toggle: this.toggle,
          index: i
        });
      }
    );
    // let crumbs= menus.breadCrumbs.map((menu, key)=>{
    //     if(key!==menus.breadCrumbs.length-1){
    //     return(

    //        <span style={{fontFamily:"Helvetica"}} key={key}>
    //            <Breadcrumb.Section link>{menu.name}</Breadcrumb.Section>
    //            <Breadcrumb.Divider icon='right chevron' />
    //        </span>

    //     )}else{
    //         return(

    //         <span style={{fontFamily:"Helvetica"}} key={key}>
    //             <Breadcrumb.Section link>{menu.name}</Breadcrumb.Section>

    //         </span>

    //      )}

    // })
    return (
      <div className="wrapper">
        <HeaderCommon
          title="National Hydrological Modelling System"
          screentitle="Hydrological Modelling System"
          bhuvanlink={true}
        />
        <Navbar
          dark
          expand="md"
          scrolling
          style={{ background: colors.final_header ,    fontSize: "14px"          }}
        >
          {!this.state.isWideEnough && <NavbarToggler onClick={this.onClick} />}
          <Collapse isOpen={this.state.collapse} navbar>
            <NavbarNav left>{menuList}</NavbarNav>
            <NavbarNav right>
              <NavItem>
                <NavLink to="/webgis-vic/map">
                  <Menu.Item
                    name="HMS Geoportal"
                    style={
                      this.state.active === "HMS Geoportal" ? activeStyle : {}
                    }
                    onClick={this._handleClick.bind(this, "HMS Geoportal")}
                  />
                </NavLink>
              </NavItem>
              {!this.state.vicmodal?<NavItem className="content"><img src={info}  style={{ width: "20px", height: "20px", cursor: "pointer" }}  onClick={this.toggle} title="About"/></NavItem> :null}
            </NavbarNav>
            {/* <AuthConsumer>
                            {({isAuth,logout})=>(
                                <NavbarNav right>
                                {(isAuth)||(localStorage.getItem("token")!==null) ? (
                                    <NavbarNav right>
                                    <NavItem>
                                    { decode(localStorage.getItem('token')).trainee==='trainee'?<Button className="btn-sm" outline color="yellow" >Welcome {decode(localStorage.getItem('token')).name}</Button>:
                            <Link to={`/profile/${decode(localStorage.getItem('token')).id}`}><Button className="btn-sm" outline color="yellow" >Welcome {decode(localStorage.getItem('token')).name}</Button></Link>
                            }                                </NavItem>
                                    <NavItem><Button className="btn-sm" onClick={logout}>logout</Button></NavItem>
                                    </NavbarNav>
                                ):(
                                    <NavbarNav right>
                                    <NavItem>
                                    <NavLink to="/login">Login</NavLink>
                                    
                                    </NavItem>
                                    
                                    </NavbarNav>
                                    
                            
                                    
                                )}
                                
                                </NavbarNav>
                            )}
                            </AuthConsumer>      */}
          </Collapse>
        </Navbar>

        <div className="main">{childrenWithExtraProp}</div>

        <Footer />
      </div>
    );
  }
}

export default withRouter(Layout);
